export default __webpack_public_path__ + "static/media/testimonial-student-two.bf428aeb.png";